import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Avatar from "@material-ui/core/Avatar";
import { BreadcrumbPage } from "../../shared";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import { Shedulerfilter } from "./SchedulerObject";
import PrintIcon from '@material-ui/icons/Print';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Moment from "react-moment";
import ShedularDetails from './ShedularDetails';
import Button from "@material-ui/core/Button";
import grey from "@material-ui/core/colors/grey";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {
  MuiThemeProvider,
  createMuiTheme,
  Tooltip,
} from "@material-ui/core";
import { customerList, equipmentList } from "./SchedulerObject"
import {
  KeyboardDatePicker,
  DatePicker
} from "@material-ui/pickers";
import { getRequest, postRequest } from "../../services/ApiServices";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import FilterComponents from "../FilterComponents/FilterComponents";
import { getCookie } from "../../services/Cookies";
import {
  FormHelperText,
  Input,
  Radio,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { useRafState } from "react-use";
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),

    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",

    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    },
    "& .tss-ynxllk-MUIDataTableFilter-root": {
      minwidth: "72px"
    }
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderRadius: 8,
  },
  fgreen:
  {
    color: "green"
  },
  fred:
  {
    color: "red"
  },
  TableTheme: {
    fontSize: "20px",
    boxShadow: "0 0 0 #eee",
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  active: {
    backgroundColor: "#F5F5F4",
  },
  table: {
    minWidth: 650,
  },
  root: {
    display: "flex",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: "0 30px",
    minHeight: "86vh",
    marginTop: "0 !important",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  radioInput: {
    padding: 0,
    "&.Mui-checked": {
      color: "#ff4717",
    },
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },

  btnStyle3: {
    color: "#ff4717",
    boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
    marginLeft: "15px",
    padding: "8px 8px",
    marginLeft: "18px",
    cursor: "pointer",
  },
}));

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});



export default function Scheduler() {
  const classes = useStyles();
  const [TransformerSchedulerList, TransformersetSchedulerList] = useState([]);
  const [selectedTransformerSchedulerList, setSelectedTransformerSchedulerList] = useState([]);
  const dispatch = useDispatch();
  const BreadcrumbList = [
    { name: "Sampling schedule recommended by VPS-Transformer", url: "" },
  ];
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());
  const [selectedSchedularData, setSelectedSchedularData] = useState([]);
  const [formObj, setFormObj] = useState(Shedulerfilter);
  const [grouping, setGrouping] = useState(getCookie('grouping'));

  useEffect(() => {
    //getShedularTransformerData(formObj);
    let getCookieval = "";
    if (localStorage.getItem('TOTFilterSetting') !== "" && localStorage.getItem('TOTFilterSetting') !== undefined && localStorage.getItem('TOTFilterSetting') !== null && localStorage.getItem('TOTFilterSetting') !== "null") {
      getCookieval = localStorage.getItem('TOTFilterSetting')
    }
    else {
      getCookieval = localStorage.getItem('GlobalFilterSetting')
    }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getShedularTransformerData(Obj);
    } else {
      getShedularTransformerData();
    }
  }, [])
  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    },
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: "500px",
          }
        }
      }
    },
  })
  const getShedularTransformerData = (data) => {
    //
    let filterObj = {};
    let Data = {};
    if (data !== "" && data !== undefined) {
      if (data.HistoricVessel == true) {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
      } else {
        filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
      }
      if (data.customerNameKey && data.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: data.customerNameKey || null } }
      if (data.TotTransformerName && data.TotTransformerName.length > 0) { filterObj = { ...filterObj, TotTransformerName: data.TotTransformerName || null } }
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    }
    else {
      filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 },{ id: 1, name: 1 }] }
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Scheduler/TransformerSchedular`;

    postRequest(url, Data)
      .then((res) => {
        res.data.forEach((d) => {
          if (d.lastSamplingDate) {
            d.lastSamplingDate = moment(d.lastSamplingDate).format('DD/MM/YYYY');
          }
          if (d.nextSamplingDate) {
            d.nextSamplingDate = moment(d.nextSamplingDate).format('DD/MM/YYYY');
          }
        })
        ////console.log(res);
        if (res.data.length) {
          console.log("transformer", res.data);
          let existContractArr = [];
          let listOfContracts = [];
          (grouping =="false" ?
            res.data.map((row) => {
              let contractIndex = existContractArr.indexOf(row.currentVesselName);
              if (contractIndex > -1) {
                let subObj = {
                  ...equipmentList,
                  Equipment: row.equimentName,
                  Make: row.make,
                  Model: row.model,
                  LoBrand: row.lastKnownLubeBrand,
                  LoGrade: row.lastKnownLubeGrade,
                  Flag: row.flag,
                  LastSampleDate: row.lastSamplingDate,
                  SamplingFrequency: row.samplingFrequency,
                  NextSampleDate: row.nextSamplingDate,
                }
                listOfContracts[contractIndex].EquipmentList.push(subObj);

              } else {
                existContractArr.push(row.currentVesselName);
                let subObj = {
                  ...equipmentList,
                  Equipment: row.equimentName,
                  Make: row.make,
                  Model: row.model,
                  LoBrand: row.lastKnownLubeBrand,
                  LoGrade: row.lastKnownLubeGrade,
                  Flag: row.flag,
                  LastSampleDate: row.lastSamplingDate,
                  SamplingFrequency: row.samplingFrequency,
                  NextSampleDate: row.nextSamplingDate,
                }
                let obj = {
                  ...customerList,
                  Asset: row.currentVesselName,
                  CustomerContract: row.customerName,
                  contractNumber: row.axContractId,
                  Flag: row.flag,
                  GroupFlag: row.groupFlag,
                  EquipmentList: [subObj]
                }
                listOfContracts.push(obj);
              }
            })
            : listOfContracts = res.data)
          TransformersetSchedulerList(listOfContracts);
        } else {
          TransformersetSchedulerList([]);
        }
        dispatch({ type: LOADING, payload: false });
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };

  const columns1 = [
    {
      name: "currentVesselName",
      label: "Asset",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "customerName",
      label: "Customer Name ",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "equimentName",
      label: " Equipment",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "make",
      label: "Make",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "model",
      label: "Model",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "lastKnownLubeBrand",
      label: "LO Brand",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "lastKnownLubeGrade",
      label: "LO Grade",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "lastSamplingDate",
      label: "Last Sample Date",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "samplingFrequency",
      label: "Sampling Frequecy",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "nextSamplingDate",
      label: "Next Sample Date ",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "flag",
      label: "Flag",
      options: {
        filter: true,
        sort: true,

        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === "Good") {
            return <><span style={{ color: "#006600" }}>Good</span> </>
          } else if (value === "OverDue") {
            return <><span style={{ color: "red" }}>OverDue</span></>
          } else if (value === "Due Soon") {
            return <><span style={{ color: "orange" }}>Due Soon</span></>
          }
        }
      }

    },

    // {
    //   name: "contractNumber",
    //   label: "Contract Number",
    //   options: {
    //     filter: true,
    //     sort: true,

    //   }
    // },
    // {
    //   name: "GroupFlag",
    //   label: "Flag",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       // //
    //       if (value === "Good") {
    //         return <><span style={{ color: "#006600" }}>Good</span> </>
    //       } else if (value === "OverDue") {
    //         return <><span style={{ color: "red" }}>OverDue</span></>
    //       } else if (value === "Due Soon") {
    //         return <><span style={{ color: "orange" }}>Due Soon</span></>
    //       }
    //     }
    //   }
    // },

  ];

  const columns = [
    {
      name: "Asset",
      label: "Asset",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "CustomerContract",
      label: "Customer Name ",

      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "GroupFlag",
      label: "Flag",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === "Good") {
            return <><span style={{ color: "#006600" }}>Good</span> </>
          } else if (value === "OverDue") {
            return <><span style={{ color: "red" }}>OverDue</span></>
          } else if (value === "Due Soon") {
            return <><span style={{ color: "orange" }}>Due Soon</span></>
          }
        }
      }
    },

  ];

  const check = () => (
    <Tooltip disableFocusListener title={toolTipValue()} >
      <IconButton disabled /*onClick={TransformerGrouping}*/ className={classes.btnStyle3} >
        {grouping =="true" ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
      </IconButton>
    </Tooltip>

  );
  const toolTipValue = () => {
    if (grouping) {
      return "Ungrouping"
    } else {
      return "Grouping"
    }
  }

  // const TransformerGrouping = () => {
  //   if (grouping) {
  //     setGrouping(false);
  //   } else {
  //     setGrouping(true);
  //   }
  // }
  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete:true,
      </>

    },

    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    filter: true,
    filterType: 'multiselect',
    responsive: 'standard',
    customToolbar: check,
    expandableRows: (grouping =="false" ? true : false),
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    download: true,
    downloadOptions: {
      filename: 'tableDownload.csv',
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true
      }
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      //debugger
      //console.log("reportlube", reportDatalube[]);
      let isExistSchedularTransformer = [];
      rowsSelected.forEach((d) => {
        isExistSchedularTransformer.push(TransformerSchedulerList[d]);
      })
      // console.log("isExistLube", isExistLube)
      //console.log("isExistFuel", isExistFuel)
      // console.log("isExistTot", isExistTot)
      //console.log("shiva",isExist)
      setSelectedTransformerSchedulerList(isExistSchedularTransformer);
    },

    onDownload: (grouping =="false" ? (buildHead, buildBody, columns, gridData) => {
      debugger;
      var myData = [];
      var newKeys = Object.keys(TransformerSchedulerList[0].EquipmentList[0]);
      var idx = 0;
      // console.log("Ddata", gridData);
      var columnsExport = [];
      var dataExport = [];
      columnsExport.push(" ");
      columns.forEach((cl) => {
        if (cl.label !== "Flag");
          columnsExport.push(cl.label);
      // console.log("tran",cl )
      })
      newKeys.forEach((k) => {
        if (k !== "ScheduleId") {
          columnsExport.push(k);
        }
      
      });
      columnsExport.push("\n");
      let i = 0;
      selectedTransformerSchedulerList.length > 0 ?
        (
          selectedTransformerSchedulerList.forEach((item) => {
            //console.log(item);
            //we have to splite the comma separator in that data
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;

              if (dfdt[0] == item.Asset && dfdt[1] == item.CustomerContract && dfdt[2] == item.Flag)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {
              let itemData = { ...item };
              //let itemData1=itemData.Asset;
              itemData.Asset = itemData.Asset.replace(/,/g, "");
              console.log("obj", itemData);
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;
              // this one for expanded rows
              let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
              itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
              delete itemData.Flag;
              delete itemData.GroupFlag;
              delete itemData.EquipmentList;
              delete itemData.contractNumber;
              itemEquipments.forEach((ie, idx) => {
                delete ie.ScheduleId
                //let di={index:idx++,data:[]}
                let data = [];
                data.push(...Object.values({ ...itemData, ...ie }));
                data.push("\n");
                dataItem.push(data);
              });
              myData.push(...dataItem);
            }
          })
        ) : (
          TransformerSchedulerList.forEach((item) => {
            //console.log(item);
            //we have to splite the comma separator in that data
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;

              if (dfdt[0] == item.Asset && dfdt[1] == item.CustomerContract && dfdt[2] == item.Flag)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {
              let itemData = { ...item };
              //let itemData1=itemData.Asset;
              itemData.Asset = itemData.Asset.replace(/,/g, "");
              console.log("obj", itemData);
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;
              // this one for expanded rows
              let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
              itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
              delete itemData.Flag;
              delete itemData.GroupFlag;
              delete itemData.EquipmentList;
              delete itemData.contractNumber;
              itemEquipments.forEach((ie, idx) => {
                //let di={index:idx++,data:[]}
                delete ie.ScheduleId
                let data = [];
                data.push(...Object.values({ ...itemData, ...ie }));
                data.push("\n");
                dataItem.push(data);
              });
              myData.push(...dataItem);
            }
          })
        )

      buildHead = () => {
        console.log(columnsExport);
        return columnsExport;
      }
      buildBody = () => {
        console.log(myData);
        return myData;
      }
      return buildHead() + buildBody();
    } :
      (buildHead, buildBody, columns, gridData) => {
  debugger
        var myData = [];
        // var newKeys = Object.keys(TransformerSchedulerList[0].EquipmentList[0]);
        var idx = 0;
        // console.log("Ddata", gridData);
        var columnsExport = [];
        var dataExport = [];
        columnsExport.push(" ");
        columns.forEach((cl) => {
          //if (cl.label !== "Flag")
            columnsExport.push(cl.label);
        });
        // newKeys.forEach((k) => {
        //   columnsExport.push(k);
        // });
        columnsExport.push("\n");
        let i = 0;
        selectedTransformerSchedulerList.length > 0 ?
          (
            selectedTransformerSchedulerList.forEach((item) => {
              //console.log(item);
              //we have to splite the comma separator in that data
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;

                if (dfdt[0] == item.currentVesselName && dfdt[1] == item.customerName)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {
                let itemData = { ...item };
                //let itemData1=itemData.Asset;
                // itemData.Asset = itemData.Asset.replace(/,/g, "");
                // console.log("obj", itemData);
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.currentVesselName = itemData.currentVesselName.replace(/,/g, "");

                // this one for expanded rows
                // let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
                // itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
                // delete itemData.Flag;
                // delete itemData.GroupFlag;
                // delete itemData.EquipmentList;
                // delete itemData.contractNumber;
                // itemEquipments.forEach((ie, idx) => {
                //let di={index:idx++,data:[]}
                let objsample = {
                  currentVesselName: itemData.currentVesselName,
                  customername: itemData.customerName,
                  equipment: itemData.equimentName,
                  make: itemData.make,
                  model: itemData.model,
                  lobrand: itemData.lastKnownLubeBrand,
                  lograde: itemData.lastKnownLubeGrade,
                  lastsampledate: itemData.lastSamplingDate,
                  samplingfrequecy: itemData.samplingFrequency,
                  nextsampledate: itemData.nextSamplingDate,
                  flag: itemData.flag,
                }
                let data = [];
                data.push(...Object.values({ ...objsample }));
                data.push("\n");
                dataItem.push(data);

                myData.push(...dataItem);
              }
            })
          ) : (
            TransformerSchedulerList.forEach((item) => {
              debugger
              //console.log(item);
              //we have to splite the comma separator in that data
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                console.log(dfdt)
                if (dfdt[0] == item.currentVesselName && dfdt[1] == item.customerName)
               
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {
                let itemData = { ...item };
                //let itemData1=itemData.Asset;
                // itemData.Asset = itemData.Asset.replace(/,/g, "");
                // console.log("obj", itemData);
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.currentVesselName = itemData.currentVesselName.replace(/,/g, "");
                // this one for expanded rows
                // let itemEquipments = itemData.EquipmentList.map(a => { return { ...a } });
                // itemData.Asset = itemData.Asset.trim() == "" ? "  " : itemData.Asset;
                // delete itemData.Flag;
                // delete itemData.GroupFlag;
                // delete itemData.EquipmentList;
                // delete itemData.contractNumber;

                //let di={index:idx++,data:[]}
                let objsample = {
                  currentVesselName: itemData.currentVesselName,
                  customername: itemData.customerName,
                  equipment: itemData.equimentName,
                  make: itemData.make,
                  model: itemData.model,
                  lobrand: itemData.lastKnownLubeBrand,
                  lograde: itemData.lastKnownLubeGrade,
                  lastsampledate: itemData.lastSamplingDate,
                  samplingfrequecy: itemData.samplingFrequency,
                  nextsampledate: itemData.nextSamplingDate,
                  flag: itemData.flag,
                }



                let data = [];
                data.push(...Object.values({ ...objsample }));
                data.push("\n");
                dataItem.push(data);

                myData.push(...dataItem);
              }
            })
          )

        buildHead = () => {
          // console.log(columnsExport);
          return columnsExport;
        }
        buildBody = () => {
          //  console.log(myData);
          return myData;
        }
        return buildHead() + buildBody();
      }
    ),
    isRowExpandable: (dataIndex, expandedRows) => {

      //if (dataIndex === 3 || dataIndex === 4) return false;

      // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
      if (expandedRows.data.length < 0 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        return false;
      return true;

    },
    rowsExpanded: [],
    renderExpandableRow: (rowData, rowMeta) => {
      //
      let expandeditem = TransformerSchedulerList.filter((value) => {
        return value.Asset === rowData[0]
      })
      const colSpan = rowData.length + 1;
      return (
        // <TableRow>
        //   <TableCell colSpan={colSpan}>Custom expandable row option. </TableCell>
        // </TableRow>
        <TableRow>

          <TableCell colSpan={colSpan}>
            <TableContainer component={Paper} className={clsx(classes.TableTheme)}>
              <Table className={classes.tableLayout}>

                <TableRow style={{ backgroundColor: grey[400] }}>
                  <StyledTableCell >
                    Equipment
                  </StyledTableCell>
                  <StyledTableCell >
                    Make
                  </StyledTableCell>
                  <StyledTableCell >
                    Model
                  </StyledTableCell>
                  <StyledTableCell >
                    LO Brand
                  </StyledTableCell>
                  <StyledTableCell >
                    LO Grade
                  </StyledTableCell>
                  <StyledTableCell >
                    Last Sample Date
                  </StyledTableCell>
                  <StyledTableCell >
                    Sampling Frequecy
                  </StyledTableCell>
                  <StyledTableCell >
                    Next Sample Date
                  </StyledTableCell>
                  <StyledTableCell >
                    Flag
                  </StyledTableCell>

                </TableRow>

                <TableBody>

                  {expandeditem[0].EquipmentList?.map((item, index) => (
                    <TableRow>
                      <TableCell >{item.Equipment}</TableCell>
                      <TableCell >{item.Make}</TableCell>
                      <TableCell >{item.Model}</TableCell>
                      <TableCell >{item.LOBrand}</TableCell>
                      <TableCell >{item.LOGrade}</TableCell>
                      <TableCell >{item.LastSampleDate}</TableCell>
                      <TableCell >{item.SamplingFrequency == 0 ? "Ad hoc" : item.SamplingFrequency}</TableCell>
                      <TableCell >{item.NextSampleDate}</TableCell>
                      <TableCell style={getFlagColor(item.Flag)}>{item.SamplingFrequecy == 0 ? "" : item.Flag}</TableCell>
                    </TableRow>

                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </TableCell>
        </TableRow >

      );
    },
    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
      console.log(curExpanded, allExpanded, rowsExpanded),
  };
  const onSubmitFilter = (obj) => {
    ////console.log(formObj);
    getShedularTransformerData(obj);
  }
  const onClear = () => {
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getShedularTransformerData(Obj);
    } else {
      getShedularTransformerData();
    }
  }
  const handleDateData = (event, type) => {
    let dateFormat = "";
    if (event) {
      dateFormat = event.format('YYYY-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
    // ////console.log(event, type);
  }

  return (
    <div>
      <Box component="main" className={classes.content + " rightbar"}>
        <Box pb={3} pt={0} display="dlock">
          <BreadcrumbPage rows={BreadcrumbList} />
        </Box>
        <Box className="decarbox1" component="div" style={{ padding: "20px" }}  >
          <FilterComponents screen={"schedulerToT"} filtervalue={["TransformerName", "CustomerName"]} applyFilter={onSubmitFilter} reset={onClear}/>
        </Box>
        {/* <Box pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Box p={2} height={1} className={classes.boxLayout}>
                <Box component="h2" m={0} className="blcopy" fontWeight="500" pb={0}>
                  Filters:
                </Box>
                <Box display="block">
                  <Box pb={1}>

                    <Grid container spacing={3}>
                      <Grid item >
                        <Box component="span" className="date-input" mr={3} fontSize="18px" >
                          Contract date
                        </Box>
                      </Grid>
                      <Grid item >
                        <Box component="span" className="date-input" mr={2}>
                          <KeyboardDatePicker
                            margin="normal"
                            className="mar0"
                            id="date-picker-dialog"
                            // label="Date picker dialog"
                            format="DD/MM/yyyy"
                            invalidDateMessage=""
                            value={formObj.contractStartDate || ""}
                            onChange={(event) => { handleDateData(event, "contractStartDate") }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item >
                        <Box component="span" className="date-input" mr={2} >
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            // label="Date picker dialog"
                            format="DD/MM/yyyy"
                            className="mar0"
                            invalidDateMessage=""
                            value={formObj.contractEndDate || ""}
                            onChange={(event) => { handleDateData(event, "contractEndDate") }}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>

                  </Box>
                  <Box component="div" >
                    <Grid container spacing={3} className="reports-filter-row mlr2" alignItems="left" >
                      <Grid spacing={3}  >
                        <Button type="button" onClick={onSubmitFilter} className={classes.btnStyle2}>
                          Apply Filter
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                 

                </Box>

              </Box>
            </Grid>
           
          </Grid>
        </Box> */}
        <Box display="block" mb={3} my={3} component="div" className="reportstablehead">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Scheduler List-Transformer"}
              data={TransformerSchedulerList}
              columns={grouping =="false" ? columns : columns1}
              options={options}
              className={classes.tableBody}
            />

          </ThemeProvider>
          {/* <Box className={classes.root} boxShadow="0 0 0 #eee">
            <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
                aria-label="collapsible table"
                className={classes.tableLayout}
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell className="bl-bg" />
                    <StyledTableCell className="bl-bg">
                      Asset
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                      Customer Contract
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                      Contract Number
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                      Flag
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {TransformerSchedulerList.length
                    ? TransformerSchedulerList.map((row) => (
                      <RowData row={row} />
                    ))
                    : (<TableCell colSpan="5">
                      <Box textAlign="center" m={2}>No Record Found</Box>
                    </TableCell>)}
                </TableBody>
              </Table>
            </TableContainer>
          </Box> */}
        </Box>
      </Box>
    </div>
  );
}
const getFlagColor = (flag) => {
  var flagcls;
  switch (flag) {
    case "Good":
      flagcls = {
        color: "#006600"
      };
      break;
    case "OverDue":
      flagcls = {
        color: "red"
      };
      break;
    case "Due Soon":
      flagcls = {
        color: "orange"
      };
      break;
    default:

  }
  return flagcls;

};
function RowData(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const tableClasses = useRowStyles();
  const classes = useStyles();
  return (
    <React.Fragment>
      <TableRow
        className={clsx(
          tableClasses.root,
          open ? classes.active : classes.inactive
        )}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Asset}
        </TableCell>
        <TableCell>
          {row.CustomerContract}
        </TableCell>
        <TableCell style={getFlagColor(row.GroupFlag)}>
          {row.GroupFlag}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <ShedularDetails row={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

    </React.Fragment>
  );
}